import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './assets/css/main.css'
import * as serviceWorker from './serviceWorker'
import axios from 'axios'
import { setupInterceptors } from './utils/interceptors'
import ErrorBoundary from './utils/ErrorBoundary'
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

setupInterceptors(axios)

const container = document.getElementById("app");
if (!container) throw new Error("Failed to find the root element");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
